var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeatherAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-25"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-25",
    cx: 250,
    cy: 357.44,
    rx: 239.42,
    ry: 125.97,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-25"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-25",
    cx: 366.74,
    cy: 383.11,
    rx: 70.72,
    ry: 40.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-25",
    d: "M42,388.37l4,2.33a5.06,5.06,0,0,0,4.61,0L292.58,251c1.27-.74,1.27-1.93,0-2.66l-4-2.34a5.15,5.15,0,0,0-4.62,0L42,385.71A1.4,1.4,0,0,0,42,388.37Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.29,347.2s.15-17.62,5.44-31.85,14.59-24.42,24.68-27.47,20.78,7.34,11.2,16.22S412,323.83,408.26,350Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.29,347.2s.15-17.62,5.44-31.85,14.59-24.42,24.68-27.47,20.78,7.34,11.2,16.22S412,323.83,408.26,350Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.48,344.53a.24.24,0,0,1-.12,0,.59.59,0,0,1-.5-.66c4.17-30.43,22.55-47.37,31.68-52.08a.59.59,0,0,1,.54,1c-8.95,4.61-27,21.25-31.06,51.2A.58.58,0,0,1,402.48,344.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.46,364.09a20.66,20.66,0,0,0-.54-7.14c-.58-2.49-2.08-4.87-2.2-7.46a8.39,8.39,0,0,1,2.68-5.84c1.52-1.45,3.53-2.46,4.56-4.3s.82-4.18,1.32-6.28a9.16,9.16,0,0,1,10.78-6.88c2.17.45,4.1,1.66,6.09,2.64a10.58,10.58,0,0,0,6.49,1.26,46,46,0,0,1,7.41-.78c4.23,0,9.56,1.44,11,5.92a5.42,5.42,0,0,1,.11,3.42l-.05.14c-1.23,3-5.09,3.65-7.58,5.14-.68.4-1.81,1-2.07,1.81s.45,1.94.8,2.71c.91,2,2.21,3.84,2.33,6.06.17,3.17-2.48,6.23-5.15,7.58a17,17,0,0,1-8.38,1.45c-1.43-.06-3-.18-4.15.64a4.47,4.47,0,0,0-1.64,3.2c-.16,1.23,0,2.48-.16,3.71a10.93,10.93,0,0,1-6.83,8.83,12.93,12.93,0,0,1-9.46-.11,9.39,9.39,0,0,1-5.09-6.57A33.41,33.41,0,0,1,397.46,364.09Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.48,371.34h0a.47.47,0,0,1-.4-.53c4.1-29.27,33.47-37,40.52-37.35a.47.47,0,0,1,.49.45.46.46,0,0,1-.44.49c-6.9.34-35.62,7.91-39.64,36.54A.47.47,0,0,1,398.48,371.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.91,352.93a.52.52,0,0,1-.26-.1,25,25,0,0,0-21-3.25.48.48,0,0,1-.58-.33.47.47,0,0,1,.33-.58,26,26,0,0,1,21.86,3.42.47.47,0,0,1,.07.66A.49.49,0,0,1,429.91,352.93Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.93,77.67l-3.44,2V70.44c0-9.55-5-13-11.24-9.5h0A24.53,24.53,0,0,0,67,81.17l-.09,1.76c-1.32-1-3.1-1.12-5.11,0h0c-7,3.65-8.45,10.2-8.81,17.1l0,.79-5.78,3.34c-3,1.67-5.57,6.63-5.8,11.18s2,7.19,5,5.52l46.74-27c3-1.67,5.57-6.39,5.81-10.93S96.9,76,93.93,77.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,91.32l-6.62,3.82c.05-.39.09-.86.11-1.24l.13-2.54c.23-4.53-2-6.84-4.93-5.17a9.73,9.73,0,0,0-3.27,3.42c-.18-5.79-3.3-8.58-7.39-6.28-4.43,2.49-8.29,10-8.64,16.76v3.7a36.77,36.77,0,0,0,.23,4.64l-5.5,3.17c-1.64.93-3.07,3.63-3.2,6.14s1.09,4,2.73,3.12l35.88-20.71a7.69,7.69,0,0,0,3.2-6C152,91.68,150.79,90.39,149.15,91.32Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Weather--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.66,195.29v154a7.59,7.59,0,0,0,.7,3.23,4.61,4.61,0,0,0,.82,1.24,4,4,0,0,0,1,.85c.11.07,7.6,4.37,7.82,4.51a3.89,3.89,0,0,1-.81-.6A5,5,0,0,1,45.11,357a9.18,9.18,0,0,1-.64-3.09V199.73a12.25,12.25,0,0,1,1.58-5.6l-7.79-4.5A12.43,12.43,0,0,0,36.66,195.29Z",
    style: {
      fill: "#FB923C",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.66,195.29v154a7.59,7.59,0,0,0,.7,3.23,4.61,4.61,0,0,0,.82,1.24,4,4,0,0,0,1,.85c.11.07,7.6,4.37,7.82,4.51a3.89,3.89,0,0,1-.81-.6A5,5,0,0,1,45.11,357a9.18,9.18,0,0,1-.64-3.09V199.73a12.25,12.25,0,0,1,1.58-5.6l-7.79-4.5A12.43,12.43,0,0,0,36.66,195.29Z",
    style: {
      fill: "#FB923C",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,55.07V210.69a13.49,13.49,0,0,1-6.13,10.6L50.59,359a3.91,3.91,0,0,1-2,.58,3.56,3.56,0,0,1-.79-.1,2.28,2.28,0,0,1-.52-.18l-.32-.18-.36-.24a2.43,2.43,0,0,1-.34-.3A4.83,4.83,0,0,1,45.11,357a7.68,7.68,0,0,1-.64-3.09V199.73a13.57,13.57,0,0,1,6.12-10.6L289.07,51.54a4.44,4.44,0,0,1,4.12-.53,2.31,2.31,0,0,1,.52.31l0,0a1.9,1.9,0,0,1,.4.4,1,1,0,0,1,.18.22,1.07,1.07,0,0,1,.2.32,2.79,2.79,0,0,1,.37.78,2.13,2.13,0,0,1,.14.54.13.13,0,0,1,0,.12,2.72,2.72,0,0,1,.1.57C295.18,54.55,295.2,54.81,295.2,55.07Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.2,55.07V210.69a13.49,13.49,0,0,1-6.13,10.6L50.59,359a3.91,3.91,0,0,1-2,.58,3.56,3.56,0,0,1-.79-.1,2.28,2.28,0,0,1-.52-.18l-.32-.18-.36-.24a2.43,2.43,0,0,1-.34-.3A4.83,4.83,0,0,1,45.11,357a7.68,7.68,0,0,1-.64-3.09V199.73a13.57,13.57,0,0,1,6.12-10.6L289.07,51.54a4.44,4.44,0,0,1,4.12-.53,2.31,2.31,0,0,1,.52.31l0,0a1.9,1.9,0,0,1,.4.4,1,1,0,0,1,.18.22,1.07,1.07,0,0,1,.2.32,2.79,2.79,0,0,1,.37.78,2.13,2.13,0,0,1,.14.54.13.13,0,0,1,0,.12,2.72,2.72,0,0,1,.1.57C295.18,54.55,295.2,54.81,295.2,55.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.7,46.76c-1.13-.69-2.69-.67-4.44.36L42.76,184.71a10.62,10.62,0,0,0-1.28.9l-.19.18a13.32,13.32,0,0,0-1,1l-.08.1a14.7,14.7,0,0,0-1.94,2.76h0l7.79,4.5a14.86,14.86,0,0,1,1.94-2.8.52.52,0,0,1,.1-.11,11.77,11.77,0,0,1,1-1c.07-.06.13-.13.21-.19a10,10,0,0,1,1.28-.91h0L289.07,51.54a4.44,4.44,0,0,1,4.12-.53C291.88,50.33,286.8,47.42,285.7,46.76Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.7,46.76c-1.13-.69-2.69-.67-4.44.36L42.76,184.71a10.62,10.62,0,0,0-1.28.9l-.19.18a13.32,13.32,0,0,0-1,1l-.08.1a14.7,14.7,0,0,0-1.94,2.76h0l7.79,4.5a14.86,14.86,0,0,1,1.94-2.8.52.52,0,0,1,.1-.11,11.77,11.77,0,0,1,1-1c.07-.06.13-.13.21-.19a10,10,0,0,1,1.28-.91h0L289.07,51.54a4.44,4.44,0,0,1,4.12-.53C291.88,50.33,286.8,47.42,285.7,46.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "38.26 189.63 38.26 189.63 38.26 189.63 38.26 189.63",
    style: {
      fill: "#FB923C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.63,195h0l0,0a2.67,2.67,0,0,0-2.69.25,8.82,8.82,0,0,0-3.56,4.8,5.56,5.56,0,0,0-.36,2v.61c0,2.07,2.31,4.86,3.39,5.85a.16.16,0,0,0,.08.06h0a.53.53,0,0,0,.76-.21c.93-1.91,3.64-7.66,3.64-9.88v-.61A3.1,3.1,0,0,0,59.63,195Zm-4.22,6.61,0-.12a2.13,2.13,0,0,1,0-.37A4,4,0,0,1,57.16,198a1.66,1.66,0,0,1,.33-.16,1.34,1.34,0,0,1,.27-.07c.71-.12,1.21.36,1.21,1.27a4,4,0,0,1-1.81,3.14C56.32,202.69,55.61,202.43,55.41,201.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79,195.66c0,1,.78,1.44,1.75.88l16.19-9.35a3.72,3.72,0,0,0,1.75-2.9c0-1-.78-1.44-1.75-.89l-16.19,9.35A3.75,3.75,0,0,0,64.79,195.66Z",
    style: {
      fill: "#FB923C",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79,195.66c0,1,.78,1.44,1.75.88l16.19-9.35a3.72,3.72,0,0,0,1.75-2.9c0-1-.78-1.44-1.75-.89l-16.19,9.35A3.75,3.75,0,0,0,64.79,195.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.84,200.13l12.36-7.2c.58-.33,1-.1,1,.53a2.23,2.23,0,0,1-1,1.74l-12.36,7.2c-.58.34-1,.1-1-.53A2.23,2.23,0,0,1,65.84,200.13Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.05,245.1l-2.45,1.37v-5.83c0-4.29-3.43-5.31-7.15-3.15h0a15,15,0,0,0-6.73,11.69V250a3.64,3.64,0,0,0-3.13.49h0a10.78,10.78,0,0,0-4.84,8.41v.36l-3.43,2a7.11,7.11,0,0,0-3.19,5.54c0,2,1.43,2.86,3.19,1.83l27.73-16.12a7.06,7.06,0,0,0,3.2-5.54C139.25,244.9,137.82,244.08,136.05,245.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.57,240.33a15.41,15.41,0,0,0-3,8.29,5.08,5.08,0,0,0-2.71.78,11.11,11.11,0,0,0-4.22,4.87c-1.88-.26-3.12-1.93-3.12-4.66a14.56,14.56,0,0,1,6.64-11.41C118.31,236.39,120.92,237.37,121.57,240.33Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 56.75, 256.7)",
    style: {
      fontSize: "51.52437973022461px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700
    }
  }, "24\xB0C"), /*#__PURE__*/React.createElement("path", {
    d: "M53,268.22a.54.54,0,0,1-.27-1l90.84-52.44a.52.52,0,0,1,.72.2.52.52,0,0,1-.19.72L53.24,268.15A.48.48,0,0,1,53,268.22Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 78.98, 267.7)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "27\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 78.98, 282.68)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "11\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 80.42, 300.62)",
    style: {
      fontSize: "9.225509643554688px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.049963364389525027em"
    }
  }, "75%"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 112.46, 282.06)",
    style: {
      fontSize: "9.225509643554688px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.049963364389525027em"
    }
  }, "15 km/h"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 61.68, 277.69)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MAX"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 61.68, 292.67)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MIN"), /*#__PURE__*/React.createElement("path", {
    d: "M74.37,299.9l-1,.56v-2.4c0-1.77-1.41-2.19-3-1.3h0a6.18,6.18,0,0,0-2.77,4.82v.32a1.51,1.51,0,0,0-1.29.21h0a4.43,4.43,0,0,0-2,3.46v.15l-1.42.82a2.92,2.92,0,0,0-1.31,2.28c0,.84.59,1.18,1.31.76l11.43-6.64a2.93,2.93,0,0,0,1.31-2.29C75.68,299.82,75.1,299.48,74.37,299.9Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6,311.77h0a.3.3,0,0,0,.4,0,1.4,1.4,0,0,0,.54-.86,1.27,1.27,0,0,0,.06-.39v-.12a2.77,2.77,0,0,0-.52-1.27v0h0a.06.06,0,0,0-.11,0,8.18,8.18,0,0,0-.55,1.88v.13A.89.89,0,0,0,65.6,311.77Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.15,309.72h0a.33.33,0,0,0,.41,0,1.37,1.37,0,0,0,.54-.86,1.24,1.24,0,0,0,.05-.38v-.13a2.93,2.93,0,0,0-.51-1.27v0h0a.07.07,0,0,0-.12,0A7.9,7.9,0,0,0,69,309v.12A.81.81,0,0,0,69.15,309.72Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,307.67h0a.33.33,0,0,0,.41,0,1.42,1.42,0,0,0,.53-.86,1.37,1.37,0,0,0,.06-.39v-.12a2.92,2.92,0,0,0-.51-1.28h0s-.09,0-.11,0a8,8,0,0,0-.55,1.88v.12A.86.86,0,0,0,72.69,307.67Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.37,299.9l-1,.56v-2.4c0-1.77-1.41-2.19-3-1.3h0a6.18,6.18,0,0,0-2.77,4.82v.32a1.51,1.51,0,0,0-1.29.21h0a4.43,4.43,0,0,0-2,3.46v.15l-1.42.82a2.92,2.92,0,0,0-1.31,2.28c0,.84.59,1.18,1.31.76l11.43-6.64a2.93,2.93,0,0,0,1.31-2.29C75.68,299.82,75.1,299.48,74.37,299.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6,311.77h0a.3.3,0,0,0,.4,0,1.4,1.4,0,0,0,.54-.86,1.27,1.27,0,0,0,.06-.39v-.12a2.77,2.77,0,0,0-.52-1.27v0h0a.06.06,0,0,0-.11,0,8.18,8.18,0,0,0-.55,1.88v.13A.89.89,0,0,0,65.6,311.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.15,309.72h0a.33.33,0,0,0,.41,0,1.37,1.37,0,0,0,.54-.86,1.24,1.24,0,0,0,.05-.38v-.13a2.93,2.93,0,0,0-.51-1.27v0h0a.07.07,0,0,0-.12,0A7.9,7.9,0,0,0,69,309v.12A.81.81,0,0,0,69.15,309.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.69,307.67h0a.33.33,0,0,0,.41,0,1.42,1.42,0,0,0,.53-.86,1.37,1.37,0,0,0,.06-.39v-.12a2.92,2.92,0,0,0-.51-1.28h0s-.09,0-.11,0a8,8,0,0,0-.55,1.88v.12A.86.86,0,0,0,72.69,307.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M102.18,288.46a2.29,2.29,0,0,1-1.13-.29,2.89,2.89,0,0,1-1.24-2.66,8.41,8.41,0,0,1,3.79-6.57,2.56,2.56,0,0,1,4.17,2.41,8.41,8.41,0,0,1-3.79,6.57A3.67,3.67,0,0,1,102.18,288.46Zm3.22-9.32a2.85,2.85,0,0,0-1.42.45h0a7.58,7.58,0,0,0-3.43,5.92,1.84,1.84,0,0,0,3,1.76,7.55,7.55,0,0,0,3.42-5.92,2.18,2.18,0,0,0-.87-2A1.55,1.55,0,0,0,105.4,279.14Zm-1.61.13h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.31,284.65l3.7-4.26a.25.25,0,0,1,.43.23l-1.6,5.94-.54-2.35Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,278.19a.36.36,0,0,1-.37-.37v-1.39a.37.37,0,0,1,.37-.37.38.38,0,0,1,.37.37v1.39A.37.37,0,0,1,103.79,278.19Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,290.74a.37.37,0,0,1-.37-.37V289a.36.36,0,0,1,.37-.37.37.37,0,0,1,.37.37v1.39A.38.38,0,0,1,103.79,290.74Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.62,281a.37.37,0,0,1-.32-.19.37.37,0,0,1,.13-.51l1.21-.69a.37.37,0,0,1,.51.13.37.37,0,0,1-.14.51l-1.21.7A.37.37,0,0,1,108.62,281Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.75,287.26a.37.37,0,0,1-.18-.69l1.2-.7a.37.37,0,0,1,.38.64l-1.21.7A.32.32,0,0,1,97.75,287.26Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.18,288.46a2.29,2.29,0,0,1-1.13-.29,2.89,2.89,0,0,1-1.24-2.66,8.41,8.41,0,0,1,3.79-6.57,2.56,2.56,0,0,1,4.17,2.41,8.41,8.41,0,0,1-3.79,6.57A3.67,3.67,0,0,1,102.18,288.46Zm3.22-9.32a2.85,2.85,0,0,0-1.42.45h0a7.58,7.58,0,0,0-3.43,5.92,1.84,1.84,0,0,0,3,1.76,7.55,7.55,0,0,0,3.42-5.92,2.18,2.18,0,0,0-.87-2A1.55,1.55,0,0,0,105.4,279.14Zm-1.61.13h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.31,284.65l3.7-4.26a.25.25,0,0,1,.43.23l-1.6,5.94-.54-2.35Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.79,278.19a.36.36,0,0,1-.37-.37v-1.39a.37.37,0,0,1,.37-.37.38.38,0,0,1,.37.37v1.39A.37.37,0,0,1,103.79,278.19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.79,290.74a.37.37,0,0,1-.37-.37V289a.36.36,0,0,1,.37-.37.37.37,0,0,1,.37.37v1.39A.38.38,0,0,1,103.79,290.74Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.62,281a.37.37,0,0,1-.32-.19.37.37,0,0,1,.13-.51l1.21-.69a.37.37,0,0,1,.51.13.37.37,0,0,1-.14.51l-1.21.7A.37.37,0,0,1,108.62,281Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.75,287.26a.37.37,0,0,1-.18-.69l1.2-.7a.37.37,0,0,1,.38.64l-1.21.7A.32.32,0,0,1,97.75,287.26Z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.49, -0.28, 0, 1, 57.35, 340.12)",
    style: {
      fontSize: "21.313190460205078px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.05001556200153338em"
    }
  }, "FRI", /*#__PURE__*/React.createElement("tspan", {
    x: 38.09,
    y: 0,
    style: {
      letterSpacing: "0.032013218023782763em"
    }
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.18,
    y: 0,
    style: {
      letterSpacing: "-0.02500778100076669em"
    }
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.95,
    y: 0,
    style: {
      letterSpacing: "0.02199381390946907em"
    }
  }, "Y")), /*#__PURE__*/React.createElement("path", {
    d: "M157.08,287.51l29.7-17.14a10.19,10.19,0,0,0,4.61-8V123.19c0-2.94-2.06-4.13-4.61-2.66l-29.7,17.14a10.2,10.2,0,0,0-4.62,8V284.85C152.46,287.79,154.53,289,157.08,287.51Z",
    style: {
      fill: "#FB923C",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 172.79, 238.51)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "27\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 172.79, 253.49)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "11\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 158.18, 246.94)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MAX"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 158.18, 261.93)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MIN"), /*#__PURE__*/React.createElement("path", {
    d: "M184.24,188.93l-2.19,1.22V185c0-3.81-3-4.71-6.34-2.79h0a13.26,13.26,0,0,0-6,10.37v.7a3.23,3.23,0,0,0-2.77.44h0a9.53,9.53,0,0,0-4.3,7.47v.31l-3,1.77a6.3,6.3,0,0,0-2.83,4.92c0,1.8,1.27,2.53,2.83,1.62l24.62-14.31a6.3,6.3,0,0,0,2.83-4.91C187.07,188.75,185.8,188,184.24,188.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,214.5h0v0a.7.7,0,0,0,.88,0,3,3,0,0,0,1.15-1.85,2.65,2.65,0,0,0,.12-.83v-.27a6.24,6.24,0,0,0-1.1-2.75l0,0h0a.13.13,0,0,0-.24,0,17,17,0,0,0-1.19,4.05v.27A1.79,1.79,0,0,0,165.35,214.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,210.09h0v0a.7.7,0,0,0,.88,0,3.08,3.08,0,0,0,1.15-1.85,3,3,0,0,0,.12-.83v-.27a6.24,6.24,0,0,0-1.1-2.75l0,0h0a.14.14,0,0,0-.25,0,17.44,17.44,0,0,0-1.18,4.05v.27A1.79,1.79,0,0,0,173,210.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.62,205.68h0l0,0a.69.69,0,0,0,.87.05,3,3,0,0,0,1.16-1.85,3,3,0,0,0,.12-.83v-.27a6.24,6.24,0,0,0-1.1-2.75l0,0h0a.14.14,0,0,0-.25,0,17.44,17.44,0,0,0-1.18,4.05v.27A1.84,1.84,0,0,0,180.62,205.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.49, -0.28, 0, 1, 159.48, 176.26)",
    style: {
      fontSize: "24.82634925842285px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.03797276457516705em"
    }
  }, "S", /*#__PURE__*/React.createElement("tspan", {
    x: 17.68,
    y: 0,
    style: {
      letterSpacing: "-0.019930456544977184em"
    }
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.01,
    y: 0,
    style: {
      letterSpacing: "0.02601449064818075em"
    }
  }, "T")), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,260l29.7-17.14a10.2,10.2,0,0,0,4.62-8V95.71c0-2.94-2.07-4.13-4.62-2.66l-29.7,17.15a10.17,10.17,0,0,0-4.61,8V257.37C200.05,260.31,202.11,261.51,204.66,260Z",
    style: {
      fill: "#FB923C",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 220.37, 211.03)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "27\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 220.38, 226.01)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "11\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 205.77, 219.47)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MAX"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 205.77, 234.45)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MIN"), /*#__PURE__*/React.createElement("path", {
    d: "M231.82,166.45l-2.18,1.22V162.5c0-3.82-3-4.72-6.34-2.8h0a13.25,13.25,0,0,0-6,10.37v.7a3.23,3.23,0,0,0-2.77.44h0a9.53,9.53,0,0,0-4.3,7.47V179l-3.05,1.77a6.3,6.3,0,0,0-2.83,4.92c0,1.8,1.27,2.53,2.83,1.62L231.82,173a6.28,6.28,0,0,0,2.83-4.91C234.65,166.27,233.38,165.55,231.82,166.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.49, -0.28, 0, 1, 205.75, 149.51)",
    style: {
      fontSize: "24.82634925842285px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.05000096992862697em"
    }
  }, "SUN"), /*#__PURE__*/React.createElement("path", {
    d: "M219.18,162.22a13.74,13.74,0,0,0-2.71,7.48,4.53,4.53,0,0,0-2.45.71,10,10,0,0,0-3.81,4.39c-1.7-.23-2.82-1.74-2.82-4.21a13.15,13.15,0,0,1,6-10.3C216.23,158.66,218.58,159.54,219.18,162.22Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.24,232.57l29.7-17.14a10.2,10.2,0,0,0,4.62-8V68.25c0-2.94-2.07-4.13-4.61-2.66L252.24,82.74a10.17,10.17,0,0,0-4.61,8V229.91C247.63,232.85,249.69,234.05,252.24,232.57Z",
    style: {
      fill: "#FB923C",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 267.96, 183.55)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "27\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 267.96, 198.53)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.04998124852367109em"
    }
  }, "11\xB0C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 253.35, 191.99)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MAX"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 253.35, 206.97)",
    style: {
      fontSize: "8.518819808959961px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.050134096378483525em"
    }
  }, "MIN"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.49, -0.28, 0, 1, 252.45, 122.65)",
    style: {
      fontSize: "24.82634925842285px",
      fill: "#455a64",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.05000096992862697em"
    }
  }, "MON"), /*#__PURE__*/React.createElement("path", {
    d: "M267.09,132.84c4.78-2.75,8.65-.52,8.65,5s-3.87,12.22-8.65,15-8.65.52-8.65-5S262.31,135.6,267.09,132.84Z",
    style: {
      fill: "#ffbda7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.48,87.64c8.59,1.64,16.81,8.89,21.34,16.58,17.54-.89,39.53,5.07,60,15.45l15.43-59.95C379.78,53.41,347.21,59,316.48,87.64Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82,104.22c17.54-.89,39.53,5.07,60,15.45l15.43-59.95C390.15,58.56,357.43,75.28,337.82,104.22Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.48,87.64c30.73-28.69,63.3-34.23,96.81-27.92-23.14-1.17-55.86,15.56-75.47,44.5C333.29,96.53,325.07,89.28,316.48,87.64Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.59,130.9c-8.31-2.71-19-.33-26.69,4.22-14.93-9.24-37.07-14.64-60-15.45l15.43-59.95C445.68,70.37,471.53,90.94,484.59,130.9Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.9,135.12c-14.93-9.24-37.07-14.64-60-15.45l15.43-59.95C434.11,69.87,454.7,100.31,457.9,135.12Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.59,130.9c-13.06-40-38.91-60.53-71.3-71.18,20.82,10.15,41.4,40.59,44.61,75.4C465.57,130.57,476.28,128.19,484.59,130.9Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.94,72.77l.43,0,.52,0a3.1,3.1,0,0,0,.44,0c.67,0,.49-.35.63-.68l.7-2.83c.56-2.34,1.26-5.48,1.87-8.65.31-1.58.58-3.17.82-4.67.11-.75.24-1.47.33-2.16s.18-1.34.26-1.94.14-1.16.19-1.65.1-.92.13-1.28c.07-.71.09-1.12.09-1.12s-.18.37-.46,1c-.15.32-.32.72-.51,1.18s-.41,1-.63,1.53L414,53.42c-.26.65-.49,1.34-.75,2-.52,1.43-1,3-1.54,4.49-1,3.06-1.89,6.15-2.53,8.48l-.75,2.81c0,.36-.36.56.21.9.1.07.27.16.39.23l.47.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.59,148.41c-6.83,2.27-8.5,2.77-13.24,10.14-4.55,7.07-9.23,20.14-13.3,30.62-7.52-2.14-20.43-9.09-25.52-12.43-4-2.61-4.72-4.58-6.88-7.14s-6.16-8.23-7.09-4.74c-.62,2.36,1.88,3.68,1.71,6.23-.14,1.36-8.35-3.79-11.59-6.06-2.15-1.51-7.14,3.21-5.14,8.33,1.77,4.53,4.61,7.4,9.69,9.55,5.37,2.28,8.18,3.41,14.92,6.44,7.05,3.16,32.86,19.54,35.73,17.74,6.54-3.23,12.53-23.46,16.49-32.2S353.72,157.15,356.59,148.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.25,147.57c-2.93,3.86-1.73,2.3-2.63,8.25-.73,4.8-10.81,51-19.94,52.88-4,.85-29.68-15.89-36.69-19.75,2.36-3.5,4.73-7.81,5.54-12.21,4.21,2.31,19.65,10,24.86,11.65,2.4-6.71,5.34-13.6,8.1-20.37C342.75,155.14,345.72,146,358.25,147.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.22,
    y: 356.72,
    width: 11.35,
    height: 21.19,
    transform: "translate(-2.59 2.79) rotate(-0.41)",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.38 364.32 344 364.84 343.83 343.4 357.85 342.84 356.38 364.32",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.16,224.54c.08,10.33,1.21,70.36,1.21,70.36.28,3,3.17,8.24,3.47,18.94.43,15.52-2.28,52.11-2.28,52.11s-4.57,3-11.39.23c0,0-8.92-51.58-11-66.93-1.78-13.39-6.86-48.44-6.86-48.44l-7,45.62a76.37,76.37,0,0,1,.73,16.49C362.62,320,357,355.4,357,355.4a18.93,18.93,0,0,1-13.06.21s-2.39-55-2.56-61.54c-.19-7.43,2.59-71.4,2.59-71.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25,372.35v-1.62c-.61,0-1,.6-1.21,2.06a31.16,31.16,0,0,1-.64,3.21,37,37,0,0,1-1.94,5.82c-1.57,4-2.91,5.45-6.55,10.1-.86,1.1-2.82,2.85-3.5,4.08s-.89,4.62.28,5.39c4.3,2.83,10.81,2.86,15.4,1.48a9.29,9.29,0,0,0,6.63-7.55c.16-1.05.09-2.12.2-3.17a15,15,0,0,1,2.8-6.61,20,20,0,0,0,2.15-3.61c.94-2.34.16-4.95-.47-7.27-.54-2-1.13-4.21-1.81-4,0,.24,0,1.23,0,1.23-.82.92-3.09,1.85-5.66,2C391.27,373.92,387.24,373.62,387.25,372.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,360.74c-.64,0-1.28,1.22-2.69,2.76a27.09,27.09,0,0,1-7.25,5.3c-4.62,2.35-13.62,6-17.68,7.86-2.55,1.16-2.4,4.24.24,6s9,2.95,16.65,1.18c4.16-1,9.55-4.84,13-4.66s9.85.09,12.37-1.67,1.48-5.48.74-8.68c-.81-3.49-1.48-9.35-2.63-9.11l-.21,1.73c-1.47,2.26-11.64,2.83-12.51.67Z",
    style: {
      fill: "#263238"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M369.34,250.81s-9.67-3.08-16.13-9.23c0,0,2.94,5.42,11.62,10.42L363,292Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.56,147.39c2.28.55,9.13,1.12,13.16,2.27,3,.86,2.87,4.58,3.49,7.31,2,8.73,2.32,27.06,2.32,27.06l.12,47.74c-7.39,5.38-37.76,8.11-53.31-3.25,0,0,1.9-55.88,1.9-63.79s4.39-17.42,16.53-18.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,113.35a14.24,14.24,0,1,1-14.24-14.24A14.25,14.25,0,0,1,375,113.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.34,123.47S383,134.32,382.1,136.1a4.91,4.91,0,0,1-2.84,2.29l.17-7.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.58,106.37a5.87,5.87,0,0,1,4.22,1.84c1.9,1.94.9,9.31-1.46,15.26L381,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.68,124c.88.52,2.12-1.16,3.19-2.28s4.59-2.66,6.34,1-1.55,8.73-4.31,9.6c-4.76,1.49-5.47-1.56-5.47-1.56l-.36,17.7h0c-3.29,4.22-10.68,9.18-14.67,8.47-3.17-.56-3.87-5.93-.83-9.45v-5.23a29.62,29.62,0,0,1-6.41.33c-3.5-.54-5.71-3.3-6.77-7.09-1.71-6.09-2.35-11-.91-23,1.59-13.12,16.85-13.26,25.1-8.07S379.68,124,379.68,124Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.26,106.67a15.73,15.73,0,0,0,4,2.19,24.87,24.87,0,0,0,14.43.94c.31-.07,4.5-1.18,4.41-1.53a7.2,7.2,0,0,0,1.65,3.61,11,11,0,0,0,3.9,2.56c.3,2.36.29,5.39.43,7.76.05.81.05,5,1.95,3.79a10.1,10.1,0,0,0,1.66-1.86,28,28,0,0,1,2.18-2.43c.57-.51.53-1.7.56-2.38a33.86,33.86,0,0,0-.15-4.27c-.11-1.46-.36-2.92-.49-4.38a7,7,0,0,1,.59-2.43,8.78,8.78,0,0,0,.37-2.79c-.16-2.93-2.41-5.43-5.05-6.73-3.7-1.81-8.17-2.1-12.2-1.77-3.26.27-6.44.27-9.71.22-.82,0-9.91-.43-9.9-.55a8.94,8.94,0,0,0,1.32,5.77l-2.88.12c-.42,0,.72,2,.8,2.06a11.72,11.72,0,0,0,1.77,1.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,107.9l5.27-2.83a2.91,2.91,0,0,0-4-1.32A3.14,3.14,0,0,0,383.44,107.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.58,142.25s7.82-1.57,10.55-3a9,9,0,0,0,3.78-3.73,12.25,12.25,0,0,1-2.15,4.41c-2,2.55-12.18,4.43-12.18,4.43Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.38,121.2a1.68,1.68,0,1,0,1.68-1.74A1.7,1.7,0,0,0,364.38,121.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.06,115.52l3.46,1.92a2.07,2.07,0,0,0-.8-2.76A1.93,1.93,0,0,0,366.06,115.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.24,132.61l-3.87,1.45a2,2,0,0,0,2.63,1.29A2.16,2.16,0,0,0,364.24,132.61Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.54,116.92l3.16-2.44a1.92,1.92,0,0,0-2.75-.42A2.1,2.1,0,0,0,350.54,116.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25,120.89a1.63,1.63,0,1,0,1.63-1.69A1.65,1.65,0,0,0,351.25,120.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.94 119.55 359.38 129.77 354.05 127.95 359.94 119.55",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,155.81c1,2.36,2.83,3.33,6.15,3.7a12.42,12.42,0,0,0,9.21-3.2l-4.14-4.12L364,156.14l-.45-4.41Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,155.81c1,2.36,2.83,3.33,6.15,3.7a12.42,12.42,0,0,0,9.21-3.2l-4.14-4.12L364,156.14l-.45-4.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.62,154.52a10.93,10.93,0,0,0-.54,4.43,7.57,7.57,0,0,0,1.47,3.69,4.07,4.07,0,0,0,3.58.39,9.77,9.77,0,0,0,3.4-7.41l-4.54.52Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,162.64s-6.77,37.37-7,40.39,3.89,13.73,6.47,13.82,7.65-9.61,7.73-12.35-3.26-41.77-3.26-41.77Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,162.73a3,3,0,0,1-3.9-.09l-.1.59s1.29,1.32,4.07.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,156.14l15.16-11.56.06-3s3.55.94,4.34,7.17c-2.16,5-6.08,9.3-11.83,12.58l-3.19-5.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.58,143s-3.56,1.65-5.08,4.16S357,157.82,357,157.82l3.63-3.3,3.37,1.62c-.32-3.19-.42-8.66-.42-8.66Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.38,198c-6.33-10.8-16.33-30.28-21.4-37-7.08-9.4-6.67-9.22-13.26-11.27-1.07,3.17-3.53,16.25,1.2,25.65l16.37,23.3c-6.65,1.59-18.55,4.7-22.58,3.87l-1.29,12c23.76-2,34.7-2.35,41.49-6.72C429.87,205.87,428.35,201.34,426.38,198Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.83,177c-3.59-4.26-6.18-17.75-3.11-27.34,6.23.53,7.71,1.79,12.21,7.34,6.56,8.07,13.78,22.55,16.71,27.38s10,17.3,9.69,20-2.53,5.27-8.32,6.87-31.2,3.27-31.2,3.27a54,54,0,0,1-1.1-12c7.64-1.49,14.59-2.93,19.09-4.21C407.8,198.28,397,180.79,393.83,177Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.78,202.71a6.39,6.39,0,0,1-3.15-1.24c-1.05-.72-2-1.53-3.15-2.18a63.75,63.75,0,0,0-8.58-3.77,1.73,1.73,0,0,0-.89-.17,1.15,1.15,0,0,0-.75.66,3.08,3.08,0,0,0-.21,1c-.07.72.11,1.45,0,2.18C370.19,206.45,386.14,206.28,387.78,202.71Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89,218.52h0l4.87-19.34-5.85-1.47-4.86,19.34a1.43,1.43,0,0,0,.53,1.5,4.66,4.66,0,0,0,4.13,1A1.45,1.45,0,0,0,375.89,218.52Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89,218.52h0l4.87-19.34-5.85-1.47-4.86,19.34a1.43,1.43,0,0,0,.53,1.5,4.66,4.66,0,0,0,4.13,1A1.45,1.45,0,0,0,375.89,218.52Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06,196.73a4.69,4.69,0,0,1,4.14,1c1,.94.71,2-.6,2.38a4.69,4.69,0,0,1-4.14-1A1.3,1.3,0,0,1,376.06,196.73Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06,196.73a4.69,4.69,0,0,1,4.14,1c1,.94.71,2-.6,2.38a4.69,4.69,0,0,1-4.14-1A1.3,1.3,0,0,1,376.06,196.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.33,198,409.85,67.3a1.68,1.68,0,1,1,3.25.84L379.59,198.8C378.74,199.48,376.56,198.89,376.33,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.78,202.77c-1.61.66-4.71,0-7.9-.23-2.57,1.81-5.78-.29-5.85-1.44l-.69-2.46s-2.67-.14-3.88,1-.5,2.79-1,3.47a9.23,9.23,0,0,0-1.28,2.75c-.22.86-1.29,2.58-1.22,3.44s0,2.81,0,2.81a7.39,7.39,0,0,0,6.33,4c4.77.34,13.14-1.64,13.14-1.64Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,93a91.8,91.8,0,0,1,50,19.36c15.12,2.63,24.44,9.25,29.84,18.57-11.65-40.65-40.19-63.18-71.3-71.18s-67-2.06-96.81,27.92c9.23-5.55,20.58-6.85,35.1-1.86A91.77,91.77,0,0,1,404.73,93Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.57,85.78A91.79,91.79,0,0,1,404.73,93l8.56-33.25C377.74,50.57,351.57,85.78,351.57,85.78Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.48,87.64c29.83-30,65.69-35.93,96.81-27.92-35.55-9.15-61.71,26.06-61.71,26.06C337.06,80.79,325.71,82.09,316.48,87.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.75,112.33a91.8,91.8,0,0,0-50-19.36l8.56-33.25C448.83,68.87,454.75,112.33,454.75,112.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.59,130.9c-11.65-40.65-40.19-63.18-71.3-71.18,35.54,9.14,41.46,52.61,41.46,52.61C469.87,115,479.19,121.58,484.59,130.9Z",
    style: {
      opacity: 0.25
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherAmico);
export default __webpack_public_path__ + "static/media/Weather-amico.c811aa1d2eddf05aecb23763a3b0f620.svg";
export { ForwardRef as ReactComponent };